import { Injectable } from '@angular/core';

type ToastType = 'success' | 'error' | 'warning' | 'info';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private toastComponent!: any;

  registerToast(toast: any) {
    this.toastComponent = toast;
  }

  showToast(message: string, type: ToastType = 'info', duration?: number) {
    if (this.toastComponent) {
      this.toastComponent.show(message, type, duration);
    }
  }
}
